module.exports = __webpack_public_path__ + "img/title2.ab813835.png";